import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getAllSubtopics } from "../helper/apicalls/subtopic";
import { getMaterialFolders, getMaterialInstitutionFolders } from "../helper/apicalls/materials";
import MaterialFolderGrid from "../components/MaterialFolderGrid";
import "../styles/MaterialFolder.scss";

const MaterialsTopic = () => {
  const { coursekey, subjectkey, topickey } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "course";
  const [activeTab, setActiveTab] = useState(initialTab);

  const [courseFolders, setCourseFolders] = useState([]);
  const [institutionFolders, setInstitutionFolders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        let subtopicsRes = [];
        let materialsRes = [];
        let instMaterialsRes = [];

        try {
          subtopicsRes = await getAllSubtopics(topickey);
        } catch (e) {
          console.error("Failed to fetch subtopics:", e);
        }

        try {
          materialsRes = await getMaterialFolders({ title: "topic", key: topickey || "" });
        } catch (e) {
          console.error("Failed to fetch topic materials:", e);
        }

        try {
          instMaterialsRes = await getMaterialInstitutionFolders({ title: "topic", key: topickey || "" });
        } catch (e) {
          console.error("Failed to fetch topic institution materials:", e);
        }

        const subtopics = Array.isArray(subtopicsRes) ? subtopicsRes : [];
        const materials = Array.isArray(materialsRes?.data)
          ? materialsRes.data
          : Array.isArray(materialsRes)
          ? materialsRes
          : [];
        const instMaterials = Array.isArray(instMaterialsRes?.data)
          ? instMaterialsRes.data
          : Array.isArray(instMaterialsRes)
          ? instMaterialsRes
          : [];

        const subtopicFolders = subtopics.map((s) => ({
          ...s,
          _kind: "subtopic",
        }));
        const courseMaterialFolders = materials.map((m) => ({
          ...m,
          _kind: "material",
        }));
        const institutionMaterialFolders = instMaterials.map((m) => ({
          ...m,
          _kind: "institution_material",
        }));

        setCourseFolders([...subtopicFolders, ...courseMaterialFolders]);
        setInstitutionFolders([...subtopicFolders, ...institutionMaterialFolders]);
      } catch (e) {
        console.error("Failed to load materials for topic", e);
        setCourseFolders([]);
        setInstitutionFolders([]);
      } finally {
        setLoading(false);
      }
    };

    if (topickey) {
      fetchData();
    }
  }, [topickey]);

  const handleOpenFolder = (folder) => {
    if (!folder) return;
    if (folder._kind === "subtopic" && folder.key) {
      if (coursekey && subjectkey && topickey) {
        navigate(
          `/materials/${coursekey}/${subjectkey}/${topickey}/${folder.key}?tab=${activeTab}`
        );
      }
      return;
    }
    if (folder._kind === "material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/materials-folder/${folderId}`);
      return;
    }
    if (folder._kind === "institution_material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/materials-folder/${folderId}?type=institution`);
      return;
    }
  };

  const currentFolders = activeTab === "institution" ? institutionFolders : courseFolders;

  return (
    <div className="materials-page">
      <div className="materials-header">
        <h1 className="materials-title">Materials - Subtopics</h1>
      </div>

      <div className="materials-tabs">
        <button
          type="button"
          className={`materials-tab ${activeTab === "course" ? "active" : ""}`}
          onClick={() => setActiveTab("course")}
        >
          Course Resources
        </button>
        <button
          type="button"
          className={`materials-tab ${activeTab === "institution" ? "active" : ""}`}
          onClick={() => setActiveTab("institution")}
        >
          Institution Resources
        </button>
      </div>

      {loading ? (
        <div className="materials-loading">Loading materials...</div>
      ) : (
        <MaterialFolderGrid folders={currentFolders} onOpen={handleOpenFolder} />
      )}
    </div>
  );
};

export default MaterialsTopic;
